<template>
  <div v-if="loading" class="preview-multi-select">
    <b>{{ filtro.name }}:</b> <span>{{ $i18n('interface.novo_filtro.selecione') }}</span>
  </div>
  <MultiSelect
    v-else
    :label="filtro.name"
    :campos="campos"
    :filtro="filtro"
    :filtro_id="filtro.filtro"
    :path="path"
    :idSelecionarTodos="idSelecionarTodos"
    @atualizar="onAtualizar"
  />
</template>
<script>
import { computed, ref, toRef, onMounted, getCurrentInstance } from 'vue';
import MultiSelect from '../../components/MultiSelect.vue';
import { useFiltroMultiSelect } from '../../composables/useFiltroMultiSelect';

const ID_SELECIONAR_TODOS = 'selecionar_todos';

export default {
  components: { MultiSelect },
  props: {
    filtro: { type: Object, required: true },
    path: { type: String, required: true },
  },
  setup(props) {
    const { proxy } = getCurrentInstance();
    const itensDoBackend = computed(() => props.filtro?.parametros?.items || []);
    const temItensDoBackend = computed(() => itensDoBackend.value.length > 0);

    const centrosViaApi = ref([]);
    const loading = ref(!temItensDoBackend.value);

    const opcoesEspeciais = computed(() => [
      { id: 'selecionar_todos', name: proxy.$i18n('interface.select_all') },
      { id: 'sem_centro_de_custo', name: proxy.$i18n('interface.without_cost_center') },
    ]);

    const campos = computed(() => {
      if (temItensDoBackend.value) {
        return itensDoBackend.value.map(item => ({ id: item.id, name: item.name }));
      }
      return [...opcoesEspeciais.value, ...centrosViaApi.value];
    });

    const idsReais = computed(() =>
      campos.value.map(item => item.id).filter(id => id !== ID_SELECIONAR_TODOS)
    );

    function expandeSelecionarTodos(selecionados) {
      const incluiTodos = selecionados.some(id => String(id) === ID_SELECIONAR_TODOS);
      if (!incluiTodos) return selecionados;
      return idsReais.value;
    }

    const { onAtualizar: onAtualizarComExpansao } = useFiltroMultiSelect({
      filtro: toRef(props, 'filtro'),
      path: toRef(props, 'path'),
      transformValor: expandeSelecionarTodos,
    });

    const { onAtualizar: onAtualizarSemExpansao } = useFiltroMultiSelect({
      filtro: toRef(props, 'filtro'),
      path: toRef(props, 'path'),
    });

    function onAtualizar(selecionados) {
      const handler = temItensDoBackend.value ? onAtualizarComExpansao : onAtualizarSemExpansao;
      handler(selecionados);
    }

    const idSelecionarTodos = computed(() => (temItensDoBackend.value ? ID_SELECIONAR_TODOS : null));

    onMounted(() => {
      if (temItensDoBackend.value) return;

      proxy.$api.get('/centro_de_custos.json').then(response => {
        centrosViaApi.value = response.data.centro_de_custos.map(centro => ({
          id: centro.id,
          name: centro.descricao,
        }));
      }).catch(error => {
        console.error('Erro ao buscar centros de custo:', error);
      }).finally(() => {
        loading.value = false;
      });
    });

    return { campos, onAtualizar, loading, idSelecionarTodos };
  },
}
</script>
